module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAC8SURBVDiNnZPbEcIgFEQXJwWkhJRgCbECS0Ir0A7Sgp1gB7SQDo4fgTG5QnByvhjYvS9AMgADMAGBLxF4AKPVr419ErV4AH3JHBrGNcEG+CfzTyXZPB4wZ4aTpGt1MFtukp5mz4tlwi18pdWgUm9GmM2+FLkrlDo75+7ALElp7VMLxfsvXZ9fnRczJ2In6S3pbAfG8ljmauaFlwMGSXFHtMcll3n8ITVmUSNQ+Q/HPpMJNCZRNBknlnlt+AAjD2cHlVyoAQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Stroke1kem.png
// module id = irgx
// module chunks = 1